import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import * as _ from 'lodash';
import { CLEAR_FB } from './reportFacebookChecklist';
import { CLEAR_SM } from './reportSocialMediaSummary';
import { CLEAR_UC_TEMPLATE } from './reportUpcomingContent';
var ns = 'likeablelocal/reportBuilder';
var UPDATE_SELECTED_CLIENT = "".concat(ns, "/UPDATE_SELECTED_CLIENT");
var UPDATE_SELECTED_CLIENT_SUCCESS = "".concat(ns, "/UPDATE_SELECTED_CLIENT_SUCCESS");
var UPDATE_SELECTED_CLIENT_FAIL = "".concat(ns, "/UPDATE_SELECTED_CLIENT_FAIL");
var CLEAR = "".concat(ns, "/CLEAR");
var SAVE_REPORT = "".concat(ns, "/SAVE_REPORT");
export var SAVE_REPORT_SUCCESS = "".concat(ns, "/SAVE_REPORT_SUCCESS");
var SAVE_REPORT_FAIL = "".concat(ns, "/SAVE_REPORT_FAIL");
var UPDATE_NON_ASYNC_FIELD = "".concat(ns, "/UPDATE_NON_ASYNC_FIELD");
export var SIMPLE_GET_REPORT = "".concat(ns, "/SIMPLE_GET_REPORT");
export var SIMPLE_GET_REPORT_SUCCESS = "".concat(ns, "/SIMPLE_GET_REPORT_SUCCESS");
export var SIMPLE_GET_REPORT_FAIL = "".concat(ns, "/SIMPLE_GET_REPORT_FAIL");
export var UPDATE_FIELD = "".concat(ns, "/UPDATE_FIELD");
export var UPDATE_FIELD_SUCCESS = "".concat(ns, "/UPDATE_FIELD_SUCCESS");
export var UPDATE_FIELD_FAIL = "".concat(ns, "/UPDATE_FIELD_FAIL");
var GET_WHITELABEL = "".concat(ns, "/GET_WHITELABEL");
var GET_WHITELABEL_SUCCESS = "".concat(ns, "/GET_WHITELABEL_SUCCESS");
var GET_WHITELABEL_FAIL = "".concat(ns, "/GET_WHITELABEL_FAIL");
var LOAD_REPORT = "".concat(ns, "/LOAD_REPORT");
export var LOAD_REPORT_SUCCESS = "".concat(ns, "/LOAD_REPORT_SUCCESS");
var LOAD_REPORT_FAIL = "".concat(ns, "/LOAD_REPORT_FAIL");

var makeDefaultContentTitle = function makeDefaultContentTitle() {
  return 'Upcoming Content Report';
};

var makeDefaultFBTitle = function makeDefaultFBTitle() {
  return 'Facebook Facelift Report';
};

var makeDefaultSMTitle = function makeDefaultSMTitle() {
  return 'Social Media Summary';
};

var initialState = {
  reportsById: {},
  justSaved: false,
  loadingReport: false,
  selectedClient: null,
  partnerTheme: null,
  gettingPartnerTheme: false,
  selectedReportType: 'socialMediaSummary',
  reportTypes: [{
    id: 1,
    name: 'Social Media Summary',
    key: 'socialMediaSummary'
  }, {
    id: 2,
    name: 'Facebook Facelift',
    key: 'facebookChecklist'
  }, {
    id: 3,
    name: 'Upcoming Content Report',
    key: 'upcomingContent'
  }],
  startDate: moment().subtract(1, 'month'),
  endDate: moment(),
  clientName: '',
  reportTitle: makeDefaultSMTitle(),
  usePartnerBranding: true,
  savingReport: false
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLEAR:
      return _.cloneDeep(initialState);

    case CLEAR_FB:
    case CLEAR_UC_TEMPLATE:
    case CLEAR_SM:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedClient: null
      });

    case LOAD_REPORT:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingReport: true
      });

    case LOAD_REPORT_SUCCESS:
      return function () {
        var data = action.result.data;
        var orgId = action.orgId ? action.orgId : data.OrganizationId;
        return _objectSpread(_objectSpread({}, state), {}, {
          loadingReport: false,
          reportsById: _objectSpread(_objectSpread({}, state.reportsById), {}, _defineProperty({}, orgId, _objectSpread(_objectSpread({}, state.reportsById[orgId]), {}, _defineProperty({}, action.reportId, action.result.data)))),
          selectedClient: {
            id: orgId,
            name: data.Organization.name,
            SocialAccountId: data.SocialAccountId,
            FacebookAdAccountId: data.FacebookAdAccountId
          },
          partnerTheme: data.whitelabel,
          selectedReportType: data.reportType === 'monthly' ? 'socialMediaSummary' : data.reportType === 'facebookChecklist' ? 'facebookChecklist' : 'upcomingContent',
          startDate: moment(data.startDate),
          endDate: moment(data.endDate),
          usePartnerBranding: true,
          reportTitle: data.name
        });
      }();

    case SAVE_REPORT:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingReport: true
      });

    case SAVE_REPORT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingReport: false,
        justSaved: true
      });

    case SAVE_REPORT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingReport: false
      });

    case GET_WHITELABEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        gettingPartnerTheme: true
      });

    case GET_WHITELABEL_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        gettingPartnerTheme: false,
        partnerTheme: action.result.data
      });

    case GET_WHITELABEL_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        gettingPartnerTheme: false
      });

    case UPDATE_SELECTED_CLIENT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedClient: {
          id: action.result.id,
          name: action.result.name,
          FacebookAdAccountId: action.result.FacebookAdAccountId,
          SocialAccountId: action.result.SocialAccountId
        }
      });

    case UPDATE_NON_ASYNC_FIELD:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.field, action.value));

    case UPDATE_FIELD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.result.field, action.result.value));

    default:
      return state;
  }
}
export function clearSettings() {
  return {
    type: CLEAR
  };
}
export function loadReport(orgId, reportId) {
  var pdfToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var env = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var url = pdfToken ? "/reporting/loadPdfReport/".concat(reportId, "?token=").concat(pdfToken).concat(env ? "&env=".concat(env) : '') : "/org/".concat(orgId, "/reports/").concat(reportId);
  return {
    types: [LOAD_REPORT, LOAD_REPORT_SUCCESS, LOAD_REPORT_FAIL],
    promise: function promise(client) {
      return client.get(url);
    },
    orgId: orgId,
    reportId: reportId
  };
}
export function simpleGetReport(orgId, reportId) {
  var url = "/org/".concat(orgId, "/reports/").concat(reportId);
  return {
    types: [SIMPLE_GET_REPORT, SIMPLE_GET_REPORT_SUCCESS, SIMPLE_GET_REPORT_FAIL],
    promise: function promise(client) {
      return client.get(url);
    },
    orgId: orgId,
    reportId: reportId
  };
}
export function getWhitelabelInfo(orgId) {
  return {
    types: [GET_WHITELABEL, GET_WHITELABEL_SUCCESS, GET_WHITELABEL_FAIL],
    promise: function promise(client) {
      return client.get("/org/".concat(orgId, "/whiteLabel"));
    }
  };
}
export function updateField(field, value) {
  return {
    types: [UPDATE_FIELD, UPDATE_FIELD_SUCCESS, UPDATE_FIELD_FAIL],
    promise: function () {
      var _promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  field: field,
                  value: value
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function promise() {
        return _promise.apply(this, arguments);
      }

      return promise;
    }()
  };
}
export function updateNonAsyncField(field, value) {
  return {
    type: UPDATE_NON_ASYNC_FIELD,
    field: field,
    value: value
  };
}
export function updateSelectedClient(id, name, FacebookAdAccountId, SocialAccountId) {
  return {
    types: [UPDATE_SELECTED_CLIENT, UPDATE_SELECTED_CLIENT_SUCCESS, UPDATE_SELECTED_CLIENT_FAIL],
    promise: function () {
      var _promise2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", {
                  id: id,
                  name: name,
                  FacebookAdAccountId: FacebookAdAccountId,
                  SocialAccountId: SocialAccountId
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function promise() {
        return _promise2.apply(this, arguments);
      }

      return promise;
    }()
  };
}
export function saveReport(template, settings, reportId) {
  var reportType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'socialMediaSummary';
  var orgId = settings.selectedClient.id;
  var data = {
    name: settings.reportTitle,
    details: template,
    startDate: settings.startDate,
    endDate: settings.endDate,
    FacebookAdAccountId: settings.selectedClient.FacebookAdAccountId,
    SocialAccountId: settings.selectedClient.SocialAccountId,
    reportType: reportType === 'socialMediaSummary' ? 'monthly' : reportType
  };
  var url = "/org/".concat(orgId, "/report");

  if (reportId) {
    url = "".concat(url, "/").concat(reportId);
  }

  return {
    data: data,
    types: [SAVE_REPORT, SAVE_REPORT_SUCCESS, SAVE_REPORT_FAIL],
    promise: function promise(client) {
      return client.put(url, {
        data: data
      });
    }
  };
}